import EcommerceMetrics from "../../components/ecommerce/EcommerceMetrics";

import StatisticsChart from "../../components/ecommerce/StatisticsChart";

import CombinedStatisticsChart1 from "../../components/ecommerce/StatisticsChart1";
import CombinedStatisticsChart2 from "../../components/ecommerce/Statics2";
import StripePaymentModal from "../../components/CreateOrderModal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

export default function CustomerHome() {
   const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
  return (
    <>
     
      <div className="gap-4 p-4 md:gap-6">

        <Elements stripe={stripePromise}>
          <StripePaymentModal
        
          />
        </Elements>
        {/* <div className="col-span-12 space-y-6 xl:col-span-12">
          <EcommerceMetrics />
     
       
        </div>

     

        <div className="col-span-12">
          <StatisticsChart />
     
        </div>
  <div className="col-span-12">
    
          <CombinedStatisticsChart1 />
        </div>
          <div className="col-span-12">
    
          <CombinedStatisticsChart2 />
        </div> */}
    
      </div>
    </>
  );
}
